<template>
  <v-app>
    <v-navigation-drawer
      persistent
      :mini-variant="miniVariant"
      :clipped="clipped"
      v-model="drawer"
      enable-resize-watcher
      app
    >
      <v-list dense>
        <template v-for="(item, i) in items">
          <v-layout row v-if="item.heading" align-center :key="i">
            <v-flex xs6>
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-flex>
          </v-layout>
          <v-divider
            dark
            v-else-if="item.divider"
            class="my-4"
            :key="i"
          ></v-divider>
          <v-list-tile :key="i" v-else @click="$router.push(item.href)">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.text }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar color="indigo" dark fixed app :clipped-left="clipped">
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-btn icon @click.stop="miniVariant = !miniVariant">
        <v-icon
          v-html="miniVariant ? 'chevron_right' : 'chevron_left'"
        ></v-icon>
      </v-btn>
      <v-btn icon @click.stop="clipped = !clipped">
        <v-icon>web</v-icon>
      </v-btn>
      <v-btn icon @click.stop="fixed = !fixed">
        <v-icon>remove</v-icon>
      </v-btn>
      <v-toolbar-title v-text="title"></v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <main>
      <v-content>
        <v-container fluid>
          <router-view></router-view>
        </v-container>
      </v-content>
    </main>
    <v-footer :fixed="fixed" app>
      <span>&copy; 2020</span>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      clipped: false,
      drawer: true,
      fixed: false,
      items: [
        { heading: 'Home' },
        { icon: 'home', text: 'Home', href: '/' },
        { divider: true },
        { heading: 'Tool' },
        { icon: 'check_circle', text: 'Length', href: '/length' },
        { icon: 'check_circle', text: 'Temperature', href: '/temperature' },
        { icon: 'check_circle', text: 'Volume', href: '/volume' },
        { icon: 'check_circle', text: 'Weight', href: '/weight' },
        { icon: 'check_circle', text: 'Time', href: '/time' },
        { icon: 'check_circle', text: 'Acceleration', href: '/acceleration' },
        {
          icon: 'check_circle',
          text: 'Amount of substance',
          href: '/amount-of-substance'
        },
        { icon: 'check_circle', text: 'Angle', href: '/angle' },
        { icon: 'check_circle', text: 'Area', href: '/area' },
        { icon: 'check_circle', text: 'Astronomical', href: '/astronomical' },
        { icon: 'check_circle', text: 'Blood Sugar', href: '/blood-sugar' },
        { icon: 'check_circle', text: 'Capacitance', href: '/capacitance' },
        {
          icon: 'check_circle',
          text: 'Computer Data Storage',
          href: '/computer'
        },
        { icon: 'check_circle', text: 'Cooking', href: '/cooking' },
        { icon: 'check_circle', text: 'Data Transfer', href: '/data-transfer' },
        { icon: 'check_circle', text: 'Density', href: '/density' },
        {
          icon: 'check_circle',
          text: 'Dynamic Viscosity',
          href: '/dynamic-viscosity'
        },
        {
          icon: 'check_circle',
          text: 'Electric Charge',
          href: '/electric-charge'
        },
        {
          icon: 'check_circle',
          text: 'Electrical Resistance',
          href: '/electrical-resistance'
        },
        { icon: 'check_circle', text: 'Energy', href: '/energy' },
        { icon: 'check_circle', text: 'Force', href: '/force' },
        { icon: 'check_circle', text: 'Illuminance', href: '/illuminance' },
        { icon: 'check_circle', text: 'Inductance', href: '/inductance' }
      ],
      miniVariant: false,
      title: 'Unit Converter'
    }
  }
}
</script>

<style lang="stylus">
@import './stylus/main';
</style>



// WEBPACK FOOTER //
// App.vue?45561150